import { typeConfigDoc, typeUser } from '@monorepo/models';

const authTokenKey = 'ac_auth_token';

class LocalStorageHelper {
    RemoveLegacyAuthTokens = (): void => {
        localStorage.removeItem('token');
        localStorage.removeItem('token_ac_local');
    }
    GetAuthToken = (): string | null => localStorage.getItem(authTokenKey);
    RemoveAuthToken = (): void => localStorage.removeItem(authTokenKey);
    SetAuthToken = (token: string): void => localStorage.setItem(authTokenKey, token);
    // dark mode
    GetDarkMode = (): boolean => localStorage.getItem('darkMode') === 'true';
    SetDarkMode = (darkMode: boolean): void => localStorage.setItem('darkMode', (!!darkMode).toString());
    // failing email
    GetFailingEmail = (): string | null => localStorage.getItem('failingEmail');
    RemoveFailingEmail = (): void => localStorage.removeItem('failingEmail');
    SetFailingEmail = (failingEmail: string) => localStorage.setItem('failingEmail', failingEmail);
    // news animation
    GetNewsVisited = (): number | null => parseInt(localStorage.getItem('newsVisitLastTime') || '0') || null;
    SetNewsVisited = (): void => localStorage.setItem('newsVisitLastTime', Date.now().toString());
    // config
    GetConfig = (): typeConfigDoc | null => {
        const ls = localStorage.getItem('mw-config');
        if (!ls) {
            return null;
        }
        try {
            const config = JSON.parse(ls) as typeConfigDoc;
            return config;
        } catch (error) {
            console.log("No se pudo parsear Config");
            return null;
        }
    }
    // ver mw
    SetConfig = (config: typeConfigDoc): void => localStorage.setItem('mw-config', JSON.stringify(config));
    // user
    GetUser = (): typeUser | null => {
        const ls = localStorage.getItem('user');
        if (!ls) {
            return null;
        }
        try {
            const user = JSON.parse(ls) as typeUser;
            return user;
        } catch (error) {
            console.log("No se pudo parsear User");
            return null;
        }
    }
    SetUser = (user: typeUser) => localStorage.setItem('user', JSON.stringify(user));
    // weather
    GetWeatherAndForecast = (): string | null => localStorage.getItem('weather');
    SetWeatherAndForecast = (weatherAndForecast: string) => localStorage.setItem('weather', weatherAndForecast);
}

export const localStorageHelper = new LocalStorageHelper();
